export default __webpack_public_path__ + "static/media/pawn1.a6691015.png";